/* global axios */
import ApiClient from './ApiClient';

// O histórico de conversas do ChatData (chatdata_imports_controller.rb). `inboxes` é a caixa de cada origem do
// arquivo, `{ "<origem>": <inbox_id> }`; a origem sem caixa não é importada.
class ChatdataImportsAPI extends ApiClient {
  constructor() {
    super('chatdata_import', { accountScoped: true });
  }

  importar(file, inboxes) {
    const formData = new FormData();
    formData.append('import_file', file);
    formData.append('inboxes', JSON.stringify(inboxes));
    return axios.post(this.url, formData, {
      headers: { 'Content-Type': 'multipart/form-data' },
    });
  }
}

export default new ChatdataImportsAPI();
